import { ForwardedRef, forwardRef, useCallback } from 'react'
import { colors } from '@pff-consumer/core-ui'
import { Text, TextDescriptionVariant } from '../../../atoms/browser-text'
import { DropdownOptionProps } from './dropdown-option.props'
import { useStyles } from './dropdown-option.web.styles'

export const DropdownOption = forwardRef((props: DropdownOptionProps, ref: ForwardedRef<HTMLLIElement | null>) => {
  const { option, isSelected, isFocused, id, renderOption, onSelectOption } = props
  const styles = useStyles()
  const isActive = isSelected || isFocused
  const activeStyles = isActive ? styles.focusedOption : ''
  const optionStyles = `${styles.dropdownOption} ${activeStyles}`
  const { value, text = '' } = option

  const handleOnClick = useCallback(() => {
    onSelectOption(option)
  }, [option, onSelectOption])

  // handling empty string values
  if (value.trim() === '') {
    return null
  }

  return (
    <li
      id={id}
      role='option'
      aria-selected={isSelected}
      key={value}
      className={optionStyles}
      ref={ref}
      tabIndex={-1}
      data-testid={`dropdown.option.${value}`}
      onClick={handleOnClick}
    >
      {renderOption ? (
        renderOption?.(id, option)
      ) : (
        <Text
          numberOfLines={1}
          textAlign='center'
          colorOverride={colors.webTextColor}
          variant={TextDescriptionVariant.MEDIUM_PRIMARY_REGULAR}
        >
          {text}
        </Text>
      )}
    </li>
  )
})
